import React from 'react'
import { Row, Col, Modal, Button, Spinner } from 'react-bootstrap'
import { MdDeleteOutline } from "react-icons/md"
import UseEditData from '../../CustomHooks/User/UseEditData'
import UseEditUserPassword from '../../CustomHooks/User/UseEditUserPassword'

const UserProfileComp = () => {

    const [editLoading, EditValidate, IsEditPress, loading, HandleEditShow, UserName, changeUserName, UserPhone, changeUserPhone, UserEmail, changeUserEmail, handleEditData, Editshow, handleEditClose] = UseEditData();
    const [isChangePasswordPress, isChangePasswordValidate, EditPasswordLoading, ValidateCurrentPassword, ValidateNewPassword, ValidateConfirmPassword, currentPassword, newPassword, confirmNewPassword, HandleChangeCurrentPassword, HandleChangeNewPassword, HandleChangeConfirmPassword, HandleEditUserPassword] = UseEditUserPassword()

    return (
        <>
            {/* start edit modal */}
            <Modal show={Editshow} onHide={handleEditClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Your Data</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Col sm="12">
                        <input
                            value={UserName}
                            onChange={changeUserName}
                            type="text"
                            className="form-control h-60 d-block mt-3 px-3"
                            placeholder="User Name"
                        />
                        <input
                            value={UserPhone}
                            onChange={changeUserPhone}
                            className="form-control h-60 d-block mt-3 px-3"
                            placeholder="User Phone"
                        />
                        <input
                            value={UserEmail}
                            onChange={changeUserEmail}
                            type="text"
                            className="form-control h-60 d-block mt-3 px-3"
                            placeholder="User Email"
                        />
                    </Col>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleEditData} className='action-button d-inline mt-2  btn text-white dark-bg' disabled={!EditValidate}>
                        {IsEditPress ? editLoading ? (<Spinner animation="border" variant="light" />) : (<span>Save</span>) : <span>Save</span>}
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* end edit modal */}
            {loading === false ? (<div className="my-2 d-flex flex-column">
                <Row className='d-flex align-items-center'>
                    <Col xs="6">
                        <div className="fw-bold fs-30 dark-color pb-4">  Profile </div>
                    </Col>
                    <Col xs="6" className='d-flex justify-content-end'>
                        <Button variant="warning" className='action-button mb-3 px-5' onClick={HandleEditShow}>Edit</Button>
                    </Col>
                </Row>
                <Row className="pt-2">
                    <Col>
                        <p><strong>Name: </strong>{UserName}</p>
                        <p><strong>phone number: </strong>{UserPhone}</p>
                        <p><strong>E-mail: </strong>{UserEmail}</p>
                    </Col>
                </Row>
                <Row className="mt-5">
                    <Col>
                        <div className="fw-bold fs-20 dark-color pb-4">Change Password</div>
                        <input
                            value={currentPassword}
                            onChange={HandleChangeCurrentPassword}
                            onBlur={ValidateCurrentPassword}
                            type="password"
                            className="form-control h-60 d-block mt-1 px-3"
                            placeholder="Current Password"
                        />
                        <input
                            value={newPassword}
                            onChange={HandleChangeNewPassword}
                            onBlur={ValidateNewPassword}
                            type="password"
                            className="form-control h-60 d-block mt-3 px-3"
                            placeholder="New Password"
                        />
                        <input
                            value={confirmNewPassword}
                            onChange={HandleChangeConfirmPassword}
                            onBlur={ValidateConfirmPassword}
                            type="password"
                            className="form-control h-60 d-block mt-3 px-3"
                            placeholder="Confirm New Password"
                        />
                        <button className="action-button d-inline mt-5  btn text-white dark-bg" onClick={HandleEditUserPassword} disabled={!isChangePasswordValidate}>
                            {isChangePasswordPress ? EditPasswordLoading ? (<Spinner animation="border" variant="light" />) : (<span>Save</span>) : <span>Save</span>}
                        </button>
                    </Col>
                </Row>
            </div>) : (
                <div className='d-flex justify-content-center align-items-center mt-5 pt-5'>
                    <Spinner animation="border" variant="danger" />
                </div>
            )}

        </>
    )
}

export default UserProfileComp
